import React from "react";
import SuccessionEmployeeCard from "./SuccessionEmployeeCard";
import { selectEmployeeForNode } from "../successionPositionGrouping.utils";

// Recursive <li> renderer for the centered org-chart layout (see
// SuccessionPlanningV2.styles.js's OrgChartListStyled for the connector-line
// CSS). `positionNode` represents one organizational position — it may carry
// more than one occupant (see successionPositionGrouping.utils); only the
// currently-selected occupant's `children` are descended into, so switching
// the occupant in the card's inline picker swaps the whole branch below it.
const OrgChartNode = ({ positionNode, selectedEmployeeByPosition, onSelectEmployee, collapsedKeys, onToggleCollapse }) => {
  const selectedEmployee = selectEmployeeForNode(positionNode, selectedEmployeeByPosition);
  const hasChildren = selectedEmployee.children?.length > 0;
  const isCollapsed = collapsedKeys.has(positionNode.positionKey);

  return (
    <li>
      <SuccessionEmployeeCard
        positionNode={positionNode}
        selectedEmployee={selectedEmployee}
        hasChildren={hasChildren}
        collapsed={isCollapsed}
        onToggleCollapse={() => onToggleCollapse(positionNode.positionKey)}
        onSelectEmployee={(employeeId) => onSelectEmployee(positionNode.positionKey, employeeId)}
      />
      {hasChildren && !isCollapsed && (
        <ul>
          {selectedEmployee.children.map((childPositionNode) => (
            <OrgChartNode
              key={childPositionNode.positionKey}
              positionNode={childPositionNode}
              selectedEmployeeByPosition={selectedEmployeeByPosition}
              onSelectEmployee={onSelectEmployee}
              collapsedKeys={collapsedKeys}
              onToggleCollapse={onToggleCollapse}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default OrgChartNode;
